window.metsoApp.initFormHandlers = function (
  formOrigin,
  gatedSections,
  gatedClasses,
  gatedAssetsType,
  formId,
  modalId,
  blockId,
  blockType
) {
  const iframe = document.getElementById(formId);
  const block = document.getElementById(blockId);
  let gatingAdded = false;
  let gatingRemoved = false;
  let formShowCallCount = 0;
  let formwasSubmitted = false;
  let formWaitingForCallCountCheck = false;
  var gatedAssets =
    gatedSections.length > 0 ||
    gatedClasses.length > 0 ||
    gatedAssetsType.length > 0;
  var iframeHeight = 10;

  window.addEventListener(
    "message",
    function (e) {
      if (e.origin === formOrigin) {
        //task handlings
        switch (e.data["task"]) {
          case "pardotShow":
          case "formShow":
            if (e.data["formID"] === formId) {
              iframeHeight > 0 &&
                typeof industrySales_hideLoader === "function" &&
                industrySales_hideLoader();

              formShowCallCount++;
              sendPageData();
              markIframeRefreshed();
              if (gatedAssets && !gatingAdded) {
                timeoutAddGating();
              }
            }

            break;

          case "pardotSendPageData":
          case "formSendPageData":
            sendPageData();

            break;

          case "pardotClear":
          case "formClear":
            if (gatedAssets && e.data["formID"] === formId) {
              formwasSubmitted = e.data["formSubmitted"] == "true";

              if (
                gatingAdded &&
                !gatingRemoved &&
                formWaitingForCallCountCheck === false
              ) {
                removeGating();
                if (formwasSubmitted) {
                  //add gating type check
                  refreshGatedAssetIframes();
                }

                showSuccess();
              }
            }

            if (!gatedAssets && e.data["formID"] === formId) {
              showSuccess();
            }

            break;

          case "pardotFormHeight":
          case "formHeight":
            if (e.data["formID"] === formId && e.data["formHeight"] > 0) {
              iframeHeight = e.data["formHeight"] + (blockType === 'pardot' ? 10 : 0); //Add 10px extra if pardot form
              setIframeHeight();
            }

            break;
        }
      }
    },
    false
  );

  refreshIframe();
  window.addEventListener("resize", setIframeHeight());

  function createEvent(eventName) {
    let event = new Event(eventName, {
      bubbles: true,
      cancelable: true
    });
    return event;
  }

  function markIframeRefreshed() {
    iframe.setAttribute("waitingForRefresh", false);
  }

  function sendPageData() {
    var data = {
      task: "siteData",
      formID: formId,
      referringPageUrl: window.location.href,
      lang: document.querySelector('html').getAttribute('lang'),
      pageName: document.title,
      masterName: window.masterPageName,
      masterUrl: window.masterPageUrl
    };
    if (!iframe) return;
    iframe.contentWindow && iframe.contentWindow.postMessage(data, formOrigin);
  }

  function sendGatedAssetData(assetUrl) {
    var data = {
      task: "gatedAssetData",
      gatedAssetsUrl: assetUrl
    };
    if (!iframe) return;
    iframe.contentWindow.postMessage(data, formOrigin);
  }

  function timeoutAddGating() {
    if (document.readyState !== "complete") {
      setTimeout(timeoutAddGating, 100);
    } else {
      addGating();
    }
  }

  function addGating() {
    if (gatingAdded) return;
    if (gatedAssetsType === "attachment-block") {
      [...block.getElementsByClassName("gated-download-link")].forEach(link => {
        if (link.href != null) {
          link.dataset.href = link.href;
          sendGatedAssetData(link.href);
        }
        link.href = "javascript:void(0);";
        link.target = "_self";
        link.dispatchEvent(createEvent("do-attachment-gating"));
      });
    } else if (gatedAssetsType === "download-list-block") {
      document.getElementById(modalId).dispatchEvent(createEvent("add-gating"));
      [...block.getElementsByClassName("success-download-link")].forEach(
        element => {
          element.addEventListener("change", function () {
            sendGatedAssetData(element.href);
          });
        }
      );
    } else {
      addPageSectionsGating();
    }

    gatingAdded = true;
  }

  function addPageSectionsGating() {
    $.each(gatedSections, function(i, value) {
      $("#" + value).hide("fast");
    });
    $.each(gatedClasses, function(i, value) {
      $("." + value).hide("fast");
    });
    $("#marketing-gate-partial").show();
    var articleUrl = document
      .querySelector("link[rel='canonical']")
      .getAttribute("href");
    sendGatedAssetData(articleUrl);
  }

  function removeGating() {
    let showCountBeforeRefresh = formShowCallCount;
    let timeOutCount = 0;
    if (gatedAssetsType === "card-with-cta-block-gating") {
      if (!(blockId && typeof blockId === "string" && blockId.length > 0))
        return;
      const cardBlock = document.getElementById(blockId);
      if (!cardBlock) return;
      var removeGatingEvent = new Event("remove-card-with-cta-gating");
      cardBlock.dispatchEvent(removeGatingEvent);
    } else if (gatedAssetsType === "attachment-block") {
      removeAllDownloadableGatings();
      markGatingRemoved();
    } else if (gatedAssetsType === "download-list-block") {
      if (formwasSubmitted) {
        formWaitingForCallCountCheck = true;
        refreshIframe();
        timeoutRemoveDownloadListGating();
      }
      else {
        var downloadListBlocks = document.getElementsByClassName('downloadlistblock');
        var extendableForm; 
        for (let i = 0; i < downloadListBlocks.length; i++) {
          extendableForm = downloadListBlocks[i].querySelector('.extendableForm');
          if (extendableForm) {
            extendableForm.dispatchEvent(createEvent("remove-downloadable-gating-all"));
          }
        }
        markGatingRemoved();
      }
    } else if (gatedAssetsType === "resource-center-page") {
      removeFilesGating();
    } else {
      removePageSectionsGating();
    }

    function removeFilesGating() {
      const filesBlock = document.getElementById(blockId);
      if (!filesBlock) return;
      var removeFilesGating = new Event("remove-files-gating");
      filesBlock.dispatchEvent(removeFilesGating);
    }

    function timeoutRemoveDownloadListGating() {
      if (showCountBeforeRefresh === formShowCallCount && timeOutCount < 6) {
        setTimeout(timeoutRemoveDownloadListGating, 500);
        timeOutCount++;
      } else {
        if (showCountBeforeRefresh < formShowCallCount) {
          document
            .getElementById(modalId)
            .dispatchEvent(createEvent("remove-downloadable-gating-single"));
        } else {
          document
            .getElementById(modalId)
            .dispatchEvent(
              createEvent("remove-downloadable-gating-all-and-open")
            );
          markGatingRemoved();
        }
        formWaitingForCallCountCheck = false;
        timeOutCount = 0;
      }
    }
  }

  function markGatingRemoved() {
    iframe.setAttribute("gatingRemoved", true);
    gatingRemoved = true;
  }

  function removePageSectionsGating() {
    gatedSections.forEach(sectionId => {
      show(document.getElementById(sectionId));
    });

    gatedClasses.forEach(gatedClass => {
      [...document.getElementsByClassName(gatedClass)].forEach(elem => {
        show(elem);
      });
    });

    hide(document.getElementById("marketing-gate-partial")); 
  }

  function removeAllDownloadableGatings() {
    if (gatedAssetsType === "attachment-block") {
      [...block.getElementsByClassName("gated-download-link")].forEach(link => {
        enableDownloadableLink(link);
        link.dispatchEvent(createEvent("remove-attachment-gating"));
        if (iframe.getAttribute("waitingForRefresh") === "false") {
          link.click();
        }
      });
    } else {
      [...document.getElementsByClassName("gated-download-link")].forEach(
        link => {
          enableDownloadableLink(link);
        }
      );
    }
  }

  function enableDownloadableLink(link) {
    if (link.dataset.href != null) {
      link.href = link.dataset.href;
    }
    link.removeAttribute("data-href");
    link.target = "_blank";
    link.setAttribute("rel", "noopener")
    link.style.backgroundImage = null;
    link.classList.remove("gated-download-link");
    link.onclick = () => null;
  }

  function refreshGatedAssetIframes() {
    var iframes = document.getElementsByTagName("iframe");
    for (var i = 0; i < iframes.length; i++) {
      if (
        iframes[i] !== iframe &&
        iframes[i].src === iframe.src &&
        iframes[i].getAttribute("gatingRemoved") !== "true"
      ) {
        iframes[i].setAttribute("waitingForRefresh", true);
        setIframeSrc(iframes[i]);
      }
    }
  }

  function showSuccess() {

    if (gatedAssetsType === "engagement-lander-page-gating") {

      var numItems = $('.salesinquiryformblock', '.engagement-lander-page__content').length;
      show(block.getElementsByClassName("submission-successful")[numItems]);
      hide(block.getElementsByClassName("fill-form-step")[0]);

    }
    else if (gatedAssetsType === "resource-center-page") {
      [...document.getElementsByClassName("fill-form-step")].forEach(elem => {
        hide(elem);
      });
    }
    else {

      [...block.getElementsByClassName("fill-form-step")].forEach(elem => {
        hide(elem);
      });

      [...block.getElementsByClassName("submission-successful")].forEach(elem => {
        show(elem);
      });
    }  

    //Scroll into success view:
    var elem = document.getElementById(formId + "-form-success");
    if (!elem) return;
    // Check any Microsoft browser (IE or Edge):
    const isMS =
      "-ms-scroll-limit" in document.documentElement.style &&
      "-ms-ime-align" in document.documentElement.style;
    if (gatedAssetsType === "engagement-lander-page-gating") {
      elem.scrollIntoView(isMS ? true : { block: "start", behavior: "smooth" });
    } else {
      elem.scrollIntoView(isMS ? true : { block: "center" });
    }
    if (gatedAssetsType === 'card-with-cta-block-gating') {
      elem.dispatchEvent(new Event('gating-removed', { bubbles: true }));
    }
  }

  function refreshIframe() {
    if (!iframe) return;
    setIframeSrc(iframe);
  }

  function setIframeSrc(el) {
    el.src = el.getAttribute("iframeSrc");
  }

  function setIframeHeight() {
    if (!iframe) return;
    iframe.style.height = iframeHeight + "px";
  }

  function show(elem) {
    if (!elem) return;
    elem.style.display = "block";
  }

  function hide(elem) {
    if (!elem) return;
    elem.style.display = "none";
  }
};

const formHandlersLoadEvent = new CustomEvent('form-handlers-loaded', {});
window.dispatchEvent(formHandlersLoadEvent);